var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChasis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28.01,
    viewBox: "0 0 24 28.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chasis_No",
    "data-name": "Chasis No",
    d: "M217.41,176.8h4a1,1,0,0,0,1-1v-6a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v2h-3.18a2.988,2.988,0,0,0-5.64,0h-3.18v-2a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-2h3.18a3.01,3.01,0,0,0,1.82,1.82V190a3.01,3.01,0,0,0-1.82,1.82h-3.18v-2a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-2h3.18a2.988,2.988,0,0,0,5.64,0h3.18v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-6a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v2h-3.18a3.01,3.01,0,0,0-1.82-1.82V175.625a3.01,3.01,0,0,0,1.82-1.82h3.18v2a1,1,0,0,0,1,1Zm1-6h2v4h-2Zm-16,4h-2v-4h2Zm0,20h-2v-4h2Zm16-4h2v4h-2Zm-8,3a1,1,0,1,1,1-1A1,1,0,0,1,210.41,193.8Zm0-20a1,1,0,1,1,1-1A1,1,0,0,1,210.41,173.806Z",
    transform: "translate(-198.41 -168.805)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChasis);
export default __webpack_public_path__ + "static/media/chasis.c46d94bb3abd8bf6993fe4cb06e5776e.svg";
export { ForwardRef as ReactComponent };